import { render, staticRenderFns } from "./NeoBreadcrumbNice.vue?vue&type=template&id=0472098f&scoped=true&"
import script from "./NeoBreadcrumbNice.vue?vue&type=script&lang=js&"
export * from "./NeoBreadcrumbNice.vue?vue&type=script&lang=js&"
import style0 from "./NeoBreadcrumbNice.vue?vue&type=style&index=0&id=0472098f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0472098f",
  null
  
)

export default component.exports